import { useCallback, useEffect, useState } from "react";

// Admin panel translations — Arabic strings are the keys (fallback = the Arabic key itself)
const EN = {
  // Tabs & chrome
  "الدورات": "Courses",
  "الاستشارات الخاصة": "Consultations",
  "العملاء المحتملون": "Leads",
  "صفحات الهبوط": "Landing Pages",
  "لافتات الفعاليات": "Event Banners",
  "المدونة": "Blog",
  "الصلاحيات": "Access",
  "نشاط العميلات": "Client Activity",
  "الإعلان الأخير للعميلات القديمات": "Final announcement to legacy clients",
  "يرسل إيميلاً واحداً لعميلات كاجابي اللواتي لم يضغطن أي رابط سحري بعد — يشرح الانتقال للمنصة الجديدة وطريقتي الدخول. كل عميلة تستلمه مرة واحدة فقط، والإرسال متدرّج حتى لا تتعثر الرسائل.": "Sends one email to Kajabi clients who never clicked any magic link — explaining the move to the new platform and both login methods. Each client receives it only once, sent at a safe pace.",
  "معاينة المستحقات والنص": "Preview recipients & copy",
  "عميلات قديمات بلا نقرة": "Legacy clients, no clicks",
  "استلمناه مسبقاً": "Already received",
  "بانتظار الإرسال": "Pending",
  "الموضوع:": "Subject:",
  "قائمة المستحقات": "Recipient list",
  "الإعلان مُرسل مسبقاً للجميع — لا يوجد مستحقات جديدة": "Announcement already sent to everyone — no new recipients",
  "ابحثي بالبريد أو الاسم...": "Search by email or name...",
  "لا توجد نتائج": "No results",
  "الدورات": "Courses",
  "لا توجد صلاحيات": "No access grants",
  "ملغاة": "Revoked",
  "منتهية": "Expired",
  "حتى": "until",
  "آخر الإيميلات": "Recent emails",
  "لم ترسل إيميلات": "No emails sent",
  "تقدم المشاهدة": "Watch progress",
  "لم تشاهد أي فيديو بعد": "No videos watched yet",
  "روابط مولّدة": "Links generated",
  "ضُغطت": "clicked",
  "آخر نقرة رابط": "Last link click",
  "آخر تسجيل دخول": "Last login",
  "الدورات الفعالة": "Active courses",
  "إيميلات ناجحة / فاشلة": "Emails sent / failed",
  "روابط ضُغطت / أُرسلت": "Links clicked / generated",
  "فيديوهات شاهدتها / أكملتها": "Videos watched / completed",
  "آراء العملاء": "Testimonials",
  "الإعدادات": "Settings",
  "التصميم والمحتوى": "Design & Content",
  "الرسائل الواردة": "Inbox",
  "تسجيل الخروج": "Log out",
  "تغيير كلمة المرور": "Change password",
  "جارٍ الاتصال بالخادم...": "Connecting to the server...",
  "الخادم يستعد حالياً — انتظري دقيقة ثم أعيدي المحاولة": "The server is waking up — wait a minute and try again",
  "أهلاً بك مايا": "Welcome back, Maya",
  "البريد الإلكتروني": "Email",
  "كلمة المرور": "Password",
  "تأكيد كلمة المرور غير متطابق": "Password confirmation does not match",
  "كلمة المرور الجديدة يجب أن تكون ٨ أحرف على الأقل": "New password must be at least 8 characters",
  "تم تغيير كلمة المرور بنجاح — استخدميها في تسجيل الدخول القادم": "Password changed successfully — use it next time you log in",
  "حدث خطأ، حاولي مجدداً": "Something went wrong, please try again",
  // Common
  "تعديل": "Edit",
  "حذف": "Delete",
  "حفظ": "Save",
  "إلغاء": "Cancel",
  "إغلاق": "Close",
  "معاينة": "Preview",
  "إعادة تسمية": "Rename",
  "حفظ التعديلات": "Save changes",
  "منشور": "Published",
  "مسودة": "Draft",
  "ظاهرة": "Visible",
  "مخفية": "Hidden",
  "— مسودة": "— draft",
  "— مع هدية": "— with gift",
  "— مرتبطة بدورة": "— linked to a course",
  "رفع من الجهاز": "Upload from device",
  "أو الصقي رابط صورة https://...": "Or paste an image URL https://...",
  "تم إرفاق الملف — استبدال": "File attached — Replace",
  "زائرة": "Guest",
  "مدى الحياة": "Lifetime",
  "يدوي": "Manual",
  "شراء": "Purchase",
  // Courses
  "إضافة الدورة": "Add course",
  "دورة جديدة": "New course",
  "تعديل الدورة": "Edit course",
  "تمت إضافة الدورة": "Course added",
  "تم تحديث الدورة": "Course updated",
  "حذف هذه الدورة نهائياً؟": "Delete this course permanently?",
  "اسم الدورة *": "Course name *",
  "اسم الدورة (EN)": "Course name (EN)",
  "وصف الدورة": "Course description",
  "المستوى": "Level",
  "عدد الدروس / النوع": "Lessons count / type",
  "الوسم (Tag)": "Tag",
  "السعر (0 = تسجيل عبر واتساب)": "Price (0 = enroll via WhatsApp)",
  "صورة الدورة (اختياري)": "Course image (optional)",
  "مثال: لجميع المستويات": "e.g. All levels",
  "مثال: ٦ دروس مسجلة": "e.g. 6 recorded lessons",
  "فيديوهات الدورة (MP4 / PDF) — ارفعي من جهازك بلا حدود": "Course videos & files (MP4 / PDF) — upload from your device, unlimited",
  "أنتَ المشرف: الرفع والحذف والتعديل متاحة لك دائماً. الحماية تنطبق على المشاهِدين فقط — تُبث لهم المشاهدة داخل الموقع ولا يظهر لهم أي زر تحميل، مع علامة مائية ببريد المشاهِد تردع التصوير.": "You are the admin: upload, delete and edit anytime. Protection applies to viewers only — videos stream inside the site with no download button, plus a moving watermark with the viewer's email to deter recording.",
  "عنوان الفيديو": "Video title",
  "مثال: الدرس الأول": "e.g. Lesson one",
  "ملف MP4 أو PDF": "MP4 or PDF file",
  "رفع الفيديو": "Upload video",
  "جارٍ الرفع...": "Uploading...",
  "تم الرفع بنجاح": "Uploaded successfully",
  "اختاري ملف MP4 أو PDF": "Choose an MP4 or PDF file",
  "تعذر الرفع — أعيدي المحاولة": "Upload failed — please try again",
  "حذف هذا الفيديو؟": "Delete this video?",
  "تم حذف الفيديو": "Video deleted",
  "لا توجد فيديوهات أو ملفات بعد في هذه الدورة": "No videos or files in this course yet",
  "فيديو": "Video",
  "مقدمة": "Teaser",
  "الفيديو التعريفي القصير (Teaser)": "Short teaser video",
  "مقطع قصير يظهر مجاناً للزائرات داخل «تفاصيل الدورة» ليتعرّفن على محتواها قبل الشراء — بدون تسجيل دخول.": "A short clip shown free to visitors inside 'Course details' so they can preview it before buying — no login required.",
  "ملف المقدمة (MP4 قصير)": "Teaser file (short MP4)",
  "رفع المقدمة": "Upload teaser",
  "تم رفع الفيديو التعريفي": "Teaser uploaded",
  "اختاري ملف MP4 للمقدمة": "Choose an MP4 for the teaser",
  "مقدمة الدورة": "Course teaser",
  "اكتبي العنوان الجديد": "Type the new title",
  "تمت إعادة التسمية": "Renamed",
  "فيديوهات": "Videos",
  // Consultations
  "قسم الاستشارات الخاصة أونلاين": "Private Online Consultations section",
  "العنوان والنص التعريفي والصورة التي تظهر في قسم «الاستشارات الخاصة» على الصفحة الرئيسية.": "The title, caption and image shown in the 'Private Consultations' section on the homepage.",
  "العنوان (عربي)": "Title (AR)",
  "النص التعريفي (عربي)": "Caption (AR)",
  "صورة القسم (مكتب / إطلالة دبي)": "Section image (office / Dubai view)",
  "باقات الجلسات": "Session packages",
  "أضيفي وعدّلي واحذفي الباقات كما تشائين — عدد غير محدود. إذا كان السعر ٠ تظهر عبارة «السعر عند التواصل».": "Add, edit and delete packages freely — unlimited. If the price is 0, 'Price on request' is shown.",
  "إضافة باقة": "Add package",
  "باقة": "Package",
  "اسم الباقة (عربي)": "Package name (AR)",
  "المدة / الوصف (عربي)": "Duration / description (AR)",
  "السعر (0 = عند التواصل)": "Price (0 = on request)",
  "العملة": "Currency",
  "طريقة الحجز": "Booking method",
  "حجز عبر واتساب": "Book via WhatsApp",
  "دفع مباشر (Stripe)": "Direct payment (Stripe)",
  "نموذج التواصل": "Contact form",
  "ظاهرة على الموقع": "Visible on site",
  "الأكثر طلباً": "Most popular",
  "لا توجد باقات — اضغطي «إضافة باقة» لبدء الإضافة.": "No packages yet — click 'Add package' to start.",
  "الحجوزات المدفوعة": "Paid bookings",
  "الباقات المدفوعة عبر Stripe تظهر هنا ويصلك إشعار بريدي عند كل حجز.": "Packages paid via Stripe appear here, and you get an email notification for each booking.",
  "لا توجد حجوزات مدفوعة بعد.": "No paid bookings yet.",
  "حفظ قسم الاستشارات": "Save consultations section",
  "تم حفظ قسم الاستشارات — حدّثي الصفحة الرئيسية لرؤية التغييرات": "Consultations section saved — refresh the homepage to see changes",
  "تعذر تحميل الإعدادات": "Could not load settings",
  "45 دقيقة": "45 minutes",
  // Pages
  "صفحة هبوط جديدة": "New landing page",
  "تعديل الصفحة": "Edit page",
  "إنشاء الصفحة": "Create page",
  "تم إنشاء الصفحة": "Page created",
  "تم تحديث الصفحة": "Page updated",
  "حذف هذه الصفحة نهائياً؟": "Delete this page permanently?",
  "الرابط (بالإنجليزية، مثال: healing-workshop) *": "Slug (English, e.g. healing-workshop) *",
  "عنوان الصفحة *": "Page title *",
  "العنوان الفرعي": "Subtitle",
  "نص الصفحة (الوصف)": "Page body (description)",
  "صورة الصفحة (اختياري)": "Page image (optional)",
  "نص زر التسجيل": "CTA button text",
  "سجّلي الآن": "Register now",
  "الهدية المجانية (Lead Magnet) — تُرسل تلقائياً لكل من يسجل": "Free gift (Lead Magnet) — sent automatically to every subscriber",
  "رفع ملف (PDF / MP3 / ZIP)": "Upload file (PDF / MP3 / ZIP)",
  "نوع الصفحة": "Page type",
  "ربط بدورة (اختياري — يظهر زر لشرائها داخل الصفحة)": "Link a course (optional — shows a buy button inside the page)",
  "فعالية": "Event",
  "ورشة عمل": "Workshop",
  "ريتريت": "Retreat",
  "لوحة التحكم": "Dashboard",
  "لوحة تحكم TheMaya": "TheMaya Dashboard",
  "تسجيل دخول المشرف": "Admin sign in",
  "دخول": "Sign in",
  "تم نسخ رابط الصفحة": "Page link copied",
  "منح الوصول": "Grant access",
  "حتى": "Until",
  "وصول": "Access",
  "يوم": "day(s)",
  "الدورات والخدمات": "Courses & Services",
  "لافتات الفعاليات القادمة": "Upcoming Event Banners",
  "تم رفع الصورة": "Image uploaded",
  "تم رفع الملف": "File uploaded",
  "إضافة دورة جديدة": "Add new course",
  "رابط الدفع المباشر (Stripe Payment Link — اختياري)": "Direct payment link (Stripe Payment Link — optional)",
  "رابط دفع الباقة الأساسية — Regular Package $550": "Regular Package payment link — $550 (Stripe)",
  "رابط دفع الباقة المميزة — VIP Package $700": "VIP Package payment link — $700 (Stripe)",
  "رابط دفع (Stripe Payment Link)": "Payment link (Stripe)",
  "رابط الدفع (buy.stripe.com/...)": "Payment link (buy.stripe.com/...)",
  "السعر الخاص (0 = بلا عرض)": "Special price (0 = no offer)",
  "نسخ الرابط": "Copy link",
  "تم نسخ رابط الدورة": "Course link copied",
  "رابط الانضمام": "Join link",
  "رابط الانضمام الخاص (القائمة البيضاء)": "Private join link (whitelist)",
  "لا يدخل من هذا الرابط إلا الإيميلات التي تضيفينها هنا — انسخيه وشاركيه في مجموعة الواتساب بعد إضافة المشتركين": "Only the emails you add here can enter through this link — copy it and share it in the WhatsApp group after adding members",
  "تم نسخ رابط الانضمام": "Join link copied",
  "فترة محددة": "Limited period",
  "يوم — يحددها المشرف فقط": "days — set by the admin only",
  "فترة محددة للجميع": "Limited period for everyone",
  "مدة الوصول — قرار المشرف لكل دورة": "Access duration — the admin's choice per course",
  "جهات الاتصال": "Contacts",
  "كل عملائك في مكان واحد — تُحفظ بياناتهم تلقائياً عند تحميل الهدية المجانية (مثل اليوميات) أو عند منحهم وصولاً لأي دورة.": "All your clients in one place — their data is saved automatically when they download the free gift (like the journal) or when you grant them course access.",
  "ابحثي بالاسم أو الإيميل": "Search by name or email",
  "لا توجد جهات اتصال بعد": "No contacts yet",
  "تصدير CSV": "Export CSV",
  "عميل دورة": "Course client",
  "سجّل بالهدية": "Gift signup",
  "منتهية": "Expired",
  "المظهر": "Appearance",
  "هوية الموقع البصرية — غيّري الألوان بضغطة واحدة": "The site's visual identity — change colors in one click",
  "لوحات فاخرة جاهزة": "Ready-made luxury palettes",
  "بنفسجي ملكي": "Royal Purple",
  "وردي ليلي": "Midnight Rose",
  "زمردي فاخر": "Luxe Emerald",
  "كحلي عميق": "Deep Navy",
  "أسود ذهبي": "Golden Onyx",
  "الحالية": "Current",
  "أو خصّصي الألوان بنفسك": "Or customize the colors yourself",
  "بقية الدرجات تُشتق تلقائياً لتحافظ على فخامة التصميم": "The remaining shades are derived automatically to keep the design luxurious",
  "حفظ المظهر": "Save appearance",
  "تم حفظ المظهر — حدّثي الصفحة لرؤيته": "Appearance saved — refresh the page to see it",
  "معاينة حية": "Live preview",
  "هكذا ستبدو البطاقات والنصوص": "This is how cards and text will look",
  "زر ذهبي": "Gold button",
  "نص ذهبي": "Gold text",
  "مخصصة": "Custom",
  "تخطيط الصفحة": "Page layout",
  "كلاسيكي متمركز": "Classic centered",
  "صورة جانبية كبيرة": "Large side photo",
  "سينمائي بخلفية كاملة (يحتاج صورة خلفية)": "Cinematic full background (needs a background image)",
  "مظهر خاص بهذه الصفحة": "Custom look for this page",
  "لون مميز خاص بالصفحة (اختياري)": "Custom page accent color (optional)",
  "لون خلفية خاص بالصفحة (اختياري)": "Custom page background color (optional)",
  "فارغ = يستخدم ألوان الموقع العامة": "Empty = uses the site's colors",
  "مسح": "Clear",
  "التحقق بخطوتين (2FA)": "Two-factor authentication (2FA)",
  "حماية إضافية — حتى لو عُرفت كلمة المرور، لا يدخل أحد بدون رمز من هاتفك": "Extra protection — even if the password is known, no one enters without a code from your phone",
  "مفعّلة": "Enabled",
  "غير مفعّلة": "Disabled",
  "إعداد التحقق بخطوتين": "Set up two-factor authentication",
  "امسحي الرمز بتطبيق Google Authenticator ثم أدخلي الرمز الظاهر": "Scan the code with Google Authenticator, then enter the code shown",
  "أو انسخي المفتاح يدوياً": "Or copy the key manually",
  "تفعيل": "Enable",
  "تم تفعيل التحقق بخطوتين — لوحتك الآن محمية بمستوى بنوك": "Two-factor authentication enabled — your dashboard now has bank-level protection",
  "إلغاء التفعيل": "Disable",
  "أدخلي الرمز الحالي من التطبيق لإلغاء التفعيل": "Enter the current code from the app to disable",
  "تم إلغاء التفعيل": "Disabled",
  "رمز التحقق (٦ أرقام)": "Verification code (6 digits)",
  "أدخلي رمز التحقق من تطبيق المصادقة": "Enter the code from your authenticator app",
  "العودة لتسجيل الدخول": "Back to login",
  "تأكيد الرمز": "Confirm code",
  "التسويق": "Marketing",
  "التسويق وإنستغرام": "Marketing & Instagram",
  "روابط ونصوص جاهزة للنشر — انسخي والصقي في منشوراتك وقصصك وإعلاناتك": "Ready-to-post links and captions — copy and paste into your posts, stories and ads",
  "ضعي هذا الرابط في بايو إنستغرام — كل روابطك في صفحة واحدة فاخرة": "Put this link in your Instagram bio — all your links in one luxury page",
  "نسخ": "Copy",
  "روابط سريعة": "Quick links",
  "صفحة الروابط (بايو إنستغرام)": "Links page (Instagram bio)",
  "الموقع الرئيسي": "Main website",
  "صفحة الهدية المجانية": "Free gift page",
  "رابط الواتساب المباشر": "Direct WhatsApp link",
  "نصوص جاهزة لكل دورة — انسخي وانشري": "Ready captions for each course — copy and post",
  "نسخ النص مع الرابط": "Copy caption with link",
  "تم نسخ النص مع الرابط": "Caption with link copied",
  "تم النسخ": "Copied",
  "جاري الحفظ…": "Saving…",
  "فشل الحفظ": "Save failed",
  "إعادة الحفظ": "Retry save",
  "بدأت إعادة الحفظ": "Retry started",
  "الإيميلات تُرسل تباعاً في الخلفية بأمان": "Emails are being sent safely one-by-one in the background",
  "أُعيد إرسال الرابط — ونُسخ أيضاً": "Link re-sent — also copied",
  "تعذر الإرسال البريدي الآن — نُسخ الرابط، أرسليه واتساب": "Email couldn't send right now — the link is copied, send it via WhatsApp",
  "خطوط الموقع": "Site fonts",
  "اختاري شخصية الخط — العناوين والنصوص تتغير معاً في كل الموقع": "Choose the font personality — headings and body text change together across the whole site",
  "الأميرية الكلاسيكية": "Classic Amiri",
  "النسخية الدافئة": "Warm Naskh",
  "الحديثة الراقية": "Elegant Modern",
  "الرقعة الفنية": "Artistic Ruqaa",
  "نموذج نص بخط المحتوى — يتضح الفرق في القراءة الطويلة": "Body text sample — the difference shows in long reading",
  "تم منح الصلاحية — الإيميل سيتأخر قليلاً، والرابط منسوخ أدناه": "Access granted — the email will arrive a bit later, and the link is copied below",
  "أُضيف للقائمة البيضاء بدون إيميل — الرابط منسوخ أدناه": "Added to the whitelist without email — the link is copied below",
  "رابط الدخول — نُسخ تلقائياً، أرسليه يدوياً (واتساب) عند الحاجة": "Access link — copied automatically, send it manually (WhatsApp) when needed",
  "إخفاء": "Hide",
  "لا توجد دورات بعد": "No courses yet",
  "حفظ كل التغييرات": "Save all changes",
  "عرض الموقع": "View site",
  "خروج": "Log out",
  "دورة": "Course",
  "عام": "General",
  // Blog
  "مقال جديد": "New post",
  "تعديل المقال": "Edit post",
  "نشر المقال": "Publish post",
  "تم نشر المقال": "Post published",
  "تم تحديث المقال": "Post updated",
  "حذف هذا المقال نهائياً؟": "Delete this post permanently?",
  "الرابط (بالإنجليزية، مثال: self-love-journey) *": "Slug (English, e.g. self-love-journey) *",
  "عنوان المقال *": "Post title *",
  "مقتطف قصير (يظهر في البطاقات)": "Short excerpt (shown on cards)",
  "نص المقال الكامل": "Full post content",
  "صورة الغلاف": "Cover image",
  "منشور على الموقع": "Published on site",
  "لا توجد مقالات بعد — اضغطي «مقال جديد» لكتابة أول مقال.": "No posts yet — click 'New post' to write your first article.",
  // Banners
  "لافتة جديدة": "New banner",
  "تعديل اللافتة": "Edit banner",
  "نشر اللافتة": "Publish banner",
  "تم نشر اللافتة": "Banner published",
  "تم تحديث اللافتة": "Banner updated",
  "حذف هذه اللافتة نهائياً؟": "Delete this banner permanently?",
  "اسم الفعالية *": "Event name *",
  "وصف قصير": "Short description",
  "التاريخ / الموعد": "Date / schedule",
  "نص الزر": "Button text",
  "رابط الزر (اختياري — اتركيه فارغاً لواتساب)": "Button link (optional — leave empty for WhatsApp)",
  "صورة اللافتة": "Banner image",
  "ظاهرة على الصفحة الرئيسية": "Visible on homepage",
  "لا توجد لافتات بعد — اضغطي «لافتة جديدة» للإعلان عن فعالية قادمة.": "No banners yet — click 'New banner' to announce an upcoming event.",
  "اللافتات الظاهرة تُعرض في قسم «الفعاليات القادمة» على الصفحة الرئيسية — للفعاليات والريتريت وورش العمل. إذا تُرك رابط الزر فارغاً يوجّه إلى واتساب برسالة جاهزة باسم الفعالية.": "Visible banners appear in the 'Upcoming events' section on the homepage — for events, retreats and workshops. If the button link is empty, it opens WhatsApp with a ready message containing the event name.",
  "ريتريت التشافي — بالي": "Healing Retreat — Bali",
  "٣ أيام من التشافي العميق": "3 days of deep healing",
  "١٥ - ١٨ سبتمبر ٢٠٢٦": "Sep 15-18, 2026",
  "https://... أو /p/event-slug": "https://... or /p/event-slug",
  // Testimonials
  "رأي جديد": "New testimonial",
  "إضافة الرأي": "Add testimonial",
  "تعديل الرأي": "Edit testimonial",
  "تمت الإضافة": "Added",
  "تم تحديث الرأي": "Testimonial updated",
  "حذف هذا الرأي نهائياً؟": "Delete this testimonial permanently?",
  "نص الاقتباس (عربي)": "Quote text (AR)",
  "الوصف": "Label",
  "مثال: مشاركة في الورشة": "e.g. Workshop participant",
  "مثال: ورشة مبارح": "e.g. Yesterday's workshop",
  // Access
  "مدة الوصول بالأيام (0 = مدى الحياة)": "Access duration in days (0 = lifetime)",
  "مثال: كورس / ورشة / VIP": "e.g. Course / Workshop / VIP",
  // Settings
  "الصورة الرئيسية": "Main portrait",
  "صورة قسم الدورات": "Courses section image",
  "عنوان الهيرو — سطر ١": "Hero title — line 1",
  "عنوان الهيرو — سطر ٢": "Hero title — line 2",
  "عنوان الهيرو — سطر ٣ (ذهبي)": "Hero title — line 3 (gold)",
  "النص التعريفي تحت العنوان": "Subtitle under the title",
  "عنوان قسم «عن مايا»": "'About Maya' section title",
  "نص قسم «عن مايا»": "'About Maya' section text",
  "عبارات الشريط المتحرك (عبارة في كل سطر)": "Marquee phrases (one per line)",
  "رقم واتساب (بصيغة دولية بدون +)": "WhatsApp number (international format, no +)",
  "رسالة واتساب الافتراضية": "Default WhatsApp message",
  "رسالة واتساب بالإنجليزية (EN)": "WhatsApp message (EN)",
  "رابط فيسبوك": "Facebook link",
  "رابط انستغرام": "Instagram link",
  "رابط انستغرام الثاني": "Second Instagram link",
  "ترجمة تلقائية من العربية": "Auto-translate from Arabic",
  "تمت الترجمة — راجعي الحقول الإنجليزية ثم احفظي": "Translated — review the English fields, then save",
  "تعذرت الترجمة — أعيدي المحاولة": "Translation failed — try again",
  "النسخة الإنجليزية — تُملأ تلقائياً عند الحفظ إذا تُركت فارغة": "English version — auto-filled on save if left empty",
  "استيراد جماعي من Kajabi (CSV)": "Bulk import from Kajabi (CSV)",
  "ارفعي ملف CSV المصدّر من Kajabi — سيُمنح كل عميل فيه وصول مدى الحياة للدورة المختارة ويصله رابط الدخول على بريده تلقائياً.": "Upload the CSV exported from Kajabi — every client in it gets lifetime access to the selected course and receives their login link by email automatically.",
  "الدورة التي اشتروها": "The course they bought",
  "ملف العملاء (Excel أو CSV)": "Clients file (Excel or CSV)",
  "منح الوصول للجميع": "Grant access to everyone",
  "سيتم منح الوصول لـ": "Access will be granted to",
  "عميل": "clients",
  "اختاري الدورة وارفعي الملف أولاً": "Choose the course and upload the file first",
  "لم يتم العثور على أي بريد إلكتروني في الملف": "No email addresses found in the file",
  "تم منح الوصول لـ": "Access granted to",
  "أُرسلت": "sent",
  "رسالة": "emails",
  "تعذّر على": "Failed for",
  "بعد إنشاء رابط الدفع في Stripe، فعّلي خيار «Redirect after payment» والصقي هذا الرابط كما هو — Stripe يستبدل الجزء الأخير تلقائياً، والوصول يُفتح فوراً بلا مراجعة يدوية:": "After creating the payment link in Stripe, enable \"Redirect after payment\" and paste this link as-is — Stripe replaces the last part automatically, and access opens instantly with no manual review:",
  "إرسال إيميل الوصول تلقائياً": "Send the access email automatically",
  "أُضيف للقائمة البيضاء بدون إيميل": "Added to whitelist without email",
  "إرسال إيميل الوصول تلقائياً (ألغِيه للإضافة الصامتة للقائمة البيضاء — مثل مجموعة Magnetic)": "Send access email automatically (uncheck for silent whitelisting — e.g. the Magnetic group)",
  "لون الخلفية الرئيسي": "Main background color",
  "لون الخلفية البديل (الأقسام)": "Alternate background (sections)",
  "لون البطاقات": "Cards color",
  "لون النص الرئيسي": "Main text color",
  "لون النص الخافت": "Muted text color",
  "اللون الذهبي المميز": "Accent gold color",
  "القيمة": "Value",
  "تم حفظ الإعدادات — حدّثي الصفحة الرئيسية لرؤية التغييرات": "Settings saved — refresh the homepage to see changes",
  "أقسام الصفحة الرئيسية": "Homepage Sections",
  "تحكمي في الأقسام الظاهرة على الصفحة الرئيسية — أخفي أي قسم متى شئتِ وأعيدي إظهاره لاحقاً.": "Control which sections appear on the homepage — hide any section anytime and bring it back later.",
  "ظاهر": "Visible",
  "مخفي": "Hidden",
  "الاستشارات 1:1": "1-on-1 Consultations",
  "نخبة العملاء": "Selected Clients",
  "قسم المقالات": "Articles Section",
  "خلفية الافتتاحية (اختياري — تظهر خلف النص وصورة مايا)": "Opening background (optional — shows behind the text and Maya's photo)",
  "صورة قسم «عن مايا» (اختياري — الافتراضي: الصورة الرئيسية)": "About section photo (optional — defaults to the main portrait)",
  "خلفية شريط الاقتباس (اختياري — تدعم الصور الشفافة PNG)": "Quote strip background (optional — transparent PNGs supported)",
  "خلفية الصفحة (اختياري — تدعم الصور الشفافة PNG)": "Page background (optional — transparent PNGs supported)",
  // Purchase requests
  "طلبات الشراء": "Purchase Requests",
  "نصوص الموقع": "Site Texts",
  "الظهور على Google (SEO)": "Google Visibility (SEO)",
  "هذه المعلومات تظهر في نتائج البحث وعند مشاركة رابط الموقع على واتساب ووسائل التواصل.": "This info appears in search results and when the site link is shared on WhatsApp and social media.",
  "عنوان الموقع (عربي)": "Site title (Arabic)",
  "عنوان الموقع (إنجليزي)": "Site title (English)",
  "وصف الموقع (عربي)": "Site description (Arabic)",
  "وصف الموقع (إنجليزي)": "Site description (English)",
  "صورة المشاركة (تظهر عند نشر الرابط)": "Share image (shown when the link is posted)",
  "نصوص أقسام الصفحة الرئيسية": "Homepage Section Texts",
  "عدّلي أي عنوان أو نص — الحقل الفارغ يعني استخدام النص الحالي الافتراضي.": "Edit any title or text — an empty field means the current default text is used.",
  "محتوى الأسئلة الشائعة": "FAQ Content",
  "أضيفي أو عدّلي الأسئلة والأجوبة. إذا كانت القائمة فارغة يعرض الموقع الأسئلة الافتراضية.": "Add or edit questions and answers. If the list is empty, the site shows the default questions.",
  "استيراد الأسئلة الحالية للتعديل عليها": "Import current questions to edit them",
  "أضيفي سؤالاً جديداً": "Add a new question",
  "سؤال": "Question",
  "السؤال (عربي)": "Question (Arabic)",
  "الجواب (عربي)": "Answer (Arabic)",
  "حفظ كل النصوص": "Save all texts",
  "تم حفظ النصوص — حدّثي الصفحة الرئيسية لرؤية التغييرات": "Texts saved — refresh the homepage to see changes",
  "تم نسخ الدورة مع كل ملفاتها — تجدينها غير منشورة": "Course duplicated with all its files — find it unpublished",
  "نسخة": "Duplicate",
  "إخفاء": "Hide",
  "إظهار": "Show",
  "مخفي": "Hidden",
  "نقل لأعلى": "Move up",
  "نقل لأسفل": "Move down",
  "مدة الوصول": "Access duration",
  "مدى الحياة": "Lifetime",
  "30 يوماً": "30 days",
  "90 يوماً": "90 days",
  "سنة كاملة": "Full year",
  "مدة مخصصة بالأيام…": "Custom duration in days…",
  "عدد الأيام": "Number of days",
  "تم منح الصلاحية وأُرسل رابط الدخول إلى بريد العميلة": "Access granted — login link emailed to the customer",
  "تم منح الصلاحية (تعذر إرسال الإيميل)": "Access granted (email could not be sent)",
  "معاينة": "Preview",
  "أصبح ظاهراً للمشتركات": "Now visible to subscribers",
  "أصبح مخفياً عن المشتركات": "Now hidden from subscribers",
  "إعادة إرسال الرابط": "Resend link",
  "أُعيد إرسال رابط الدخول إلى بريد العميلة": "Login link re-sent to the customer's email",
  "رابط يوتيوب": "YouTube link",
  "بريد الدعم الفني": "Support email",
  "للدعم": "Support",
  "طلبات الوصول القادمة من صفحة نجاح الدفع — اضغطي موافقة ليصل العميلة إيميل شكر مع رابط دخول مباشر للكورس": "Access requests from the payment success page — approve to send the customer a thank-you email with a direct course access link",
  "طلبات معلّقة": "Pending requests",
  "لا توجد طلبات معلّقة": "No pending requests",
  "السجل": "History",
  "موافقة وإرسال الرابط": "Approve & send link",
  "رفض": "Reject",
  "تمت الموافقة وأُرسل رابط الدخول إلى بريد العميلة": "Approved — access link sent to the customer's email",
  "تم رفض الطلب": "Request rejected",
  "تمت الموافقة": "Approved",
  "مرفوض": "Rejected",
  "بعد إنشاء رابط الدفع في Stripe، فعّلي خيار «Redirect after payment» والصقي هذا الرابط:": "After creating the Stripe Payment Link, enable 'Redirect after payment' and paste this URL:",
  "رسائل اليوم": "Emails today",
  "فشل": "failed",
  "نسخ موفّرة جاهزة": "Data-saver copies",
  "قيد التحويل": "converting",
  "جهات جديدة هذا الأسبوع": "New contacts this week",
  "إجمالي جهات الاتصال": "Total contacts",
  "إدارة صفحة الروابط": "Manage your links page",
  "أضيفي، عدّلي، رتّبي — والتغييرات تظهر فوراً على صفحة /links بعد الحفظ": "Add, edit, reorder — changes appear on /links right after saving",
  "حفظ صفحة الروابط": "Save links page",
  "تم الحفظ — صفحة الروابط محدثة": "Saved — links page updated",
  "النص بالعربية": "Arabic label",
  "النص بالإنجليزية": "English label",
  "صورة الرابط": "Link image",
  "إزالة الصورة (تظهر الأيقونة بدلاً منها)": "Remove image (the icon shows instead)",
  "أضيفي رابطاً جديداً": "Add a new link",
  "ألوان صفحة الروابط": "Links page colors",
  "افتراضي (ألوان الموقع)": "Default (site colors)",
  "صورة الخلفية": "Background image",
  "بدون صورة خلفية": "No background image",
  "ارفعي صورة": "Upload image",
  "تم رفع الصورة": "Image uploaded",
  "أتمتة إنستغرام": "Instagram Automation",
  "ربط إنستغرام": "Instagram connection",
  "متصل بحساب": "Connected to",
  "جاهز للربط — اضغطي الزر وسجّلي دخولك بإنستغرام": "Ready to connect — press the button and log in with Instagram",
  "بانتظار إعداد مفاتيح Meta على الخادم — أرسلي لي «مفاتيحي جاهزة» عندما تنهين الخطوات": "Waiting for Meta keys on the server — message me 'my keys are ready' when you finish the steps",
  "ربط حساب إنستغرام": "Connect Instagram account",
  "بيانات الربط (تلصقينها في لوحة Meta)": "Connection details (paste these into your Meta dashboard)",
  "تم النسخ": "Copied",
  "تم ربط إنستغرام بنجاح": "Instagram connected successfully",
  "تعذر ربط إنستغرام — جرّبي مجدداً": "Instagram connection failed — try again",
  "قواعد الرد التلقائي": "Auto-reply rules",
  "عندما يكتب أحد تعليقاً يحتوي كلمة مفتاحية، يرد النظام تلقائياً بالرد الذي تحددينه": "When someone comments with a keyword, the system auto-replies with your text",
  "الكلمات المفتاحية مفصولة بفاصلة — مثال: sunset، سانسيت، سانست": "Keywords separated by commas — e.g.: sunset, سانسيت, سانست",
  "الرد التلقائي — مثال: أهلاً فيكِ 🤍 هذا رابط التسجيل: themaya.online/p/sunset": "Auto-reply — e.g.: Welcome 🤍 here is the link: themaya.online/p/sunset",
  "أدخلي الكلمات المفتاحية ونص الرد": "Enter keywords and a reply text",
  "أضيفي القاعدة": "Add rule",
  "تمت إضافة القاعدة": "Rule added",
  "تم حذف القاعدة": "Rule deleted",
  "لا قواعد بعد — أضيفي أول قاعدة فوق": "No rules yet — add your first one above",
  "مفعّلة": "Active",
  "متوقفة": "Paused",
  "سجل التعليقات الأخير": "Recent comments log",
  "لا نشاط بعد — التعليقات المطابقة تظهر هنا وتُحفظ كعملاء محتملين في جهات الاتصال": "No activity yet — matched comments appear here and are saved as leads in Contacts",
  "تم الرد": "Replied",
  "تطابق — بانتظار الربط": "Matched — awaiting connection",
  "بدون تطابق": "No match",
  "تعليق فرعي": "Nested comment",
  "خطأ": "Error",
  "الحساب يديره شخص آخر؟": "Someone else manages the account?",
  "أنشئي رابطاً آمناً يُستخدم مرة واحدة وأرسليه له — يفتحه، يسجّل دخوله بحساب فيسبوك المرتبط بالصفحة، ويضغط سماح. بدون مشاركة كلمة مرورك أبداً.": "Create a secure one-time link and send it to them — they open it, log in with the Facebook account linked to the page, and tap Allow. Your password is never shared.",
  "أنشئي رابط الربط للمدير": "Create manager connect link",
  "تم إنشاء الرابط — أرسليه لمن يدير الحساب": "Link created — send it to the account manager",
};

export const getAdminLang = () => localStorage.getItem("themaya_admin_lang") || "ar";

export const setAdminLang = (lang) => {
  localStorage.setItem("themaya_admin_lang", lang);
  window.dispatchEvent(new Event("admin-lang"));
};

export const useAdminT = () => {
  const [lang, setLang] = useState(getAdminLang());
  useEffect(() => {
    const onChange = () => setLang(getAdminLang());
    window.addEventListener("admin-lang", onChange);
    return () => window.removeEventListener("admin-lang", onChange);
  }, []);
  const t = useCallback((str) => (lang === "en" && str ? EN[str] ?? str : str), [lang]);
  return { t, lang };
};
